import { ReactNode } from 'react';

interface DetailSectionProps {
  title: string;
  children: ReactNode;
  description?: string;
}

export function DetailSection({ title, children, description }: DetailSectionProps) {
  return (
    <div className="space-y-2">
      <div>
        <h3 className="text-sm font-semibold tracking-tight">{title}</h3>
        {description && (
          <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      <div className="text-sm leading-6 text-foreground">{children}</div>
    </div>
  );
}
